import React, { useState } from 'react';
import { adminLogin } from '../../api/admin';
import './AdminLogin.css';

function AdminLogin() {
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);

  const handleSubmit = async () => {
    if (!email || !password) { setError('Please enter email and password'); return; }
    setLoading(true);
    setError('');
    try {
      const res = await adminLogin(email, password);
      if (res.success) {
        localStorage.setItem('admin_token', res.data.token);
        localStorage.setItem('admin_user', JSON.stringify(res.data.admin));
        window.location.href = '/admin/dashboard';
      } else {
        setError(res.message || 'Login failed');
      }
    } catch {
      setError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleKey = (e) => { if (e.key === 'Enter') handleSubmit(); };

  return (
    <div className="al-page">
      <div className="al-box">
        <div className="al-logo">
          <img 
            src={`${process.env.PUBLIC_URL}/logo.png`} 
            alt="Heaven Green Infra. Landscape" 
            className="al-logo__img"
            onError={(e) => {
              e.target.style.display = 'none';
              e.target.parentElement.querySelector('.al-logo__fallback').style.display = 'block';
            }}
          />
          <div className="al-logo__fallback" style={{ display: 'none' }}>🌿</div>
          <h1>Heaven Green</h1>
          <p>Admin Panel</p>
        </div>

        {error && <div className="al-error">{error}</div>}

        <div className="al-field">
          <label>Email Address</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            onKeyDown={handleKey}
            placeholder="admin@heavengreenlandscape.com"
            autoFocus
          />
        </div>

        <div className="al-field">
          <label>Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyDown={handleKey}
            placeholder="Enter your password"
          />
        </div>

        <button className="al-btn" onClick={handleSubmit} disabled={loading}>
          {loading ? 'Signing in...' : 'Sign In'}
        </button>

        <a href="/" className="al-back"> Back to Website</a>
      </div>
    </div>
  );
}

export default AdminLogin;